module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-9.3b9e6fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-9.png
// module id = 199
// module chunks = 0